function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-bank",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "29-desktop-UI-bank",
  transform: "translate(-190.000000, -804.000000)",
  fillRule: "nonzero",
  strokeWidth: 2
}, React.createElement("g", {
  id: "Group-3-bank",
  transform: "translate(186.000000, 805.000000)"
}, React.createElement("path", {
  d: "M34.9756427,0.545212106 L61.2968339,15.254113 C62.2610606,15.7929456 62.6059107,17.011416 62.0670781,17.9756427 C61.7136278,18.6081328 61.0457398,19 60.3211911,19 L7.67880886,19 C6.57423936,19 5.67880886,18.1045695 5.67880886,17 C5.67880886,16.2754513 6.07067607,15.6075634 6.70316615,15.254113 L33.0243573,0.545212106 C33.6306621,0.206394725 34.3693379,0.206394725 34.9756427,0.545212106 Z",
  id: "Triangle-2-bank",
  stroke: "#3F5063",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M8,51 L60,51 C61.1045695,51 62,51.8954305 62,53 L62,54 C62,55.1045695 61.1045695,56 60,56 L8,56 C6.8954305,56 6,55.1045695 6,54 L6,53 C6,51.8954305 6.8954305,51 8,51 Z",
  id: "Rectangle-bank",
  stroke: "#3F5063",
  strokeLinecap: "round"
}), React.createElement("g", {
  id: "Group-2-bank",
  transform: "translate(12.000000, 23.000000)",
  stroke: "#6EC18A"
}, React.createElement("rect", {
  id: "Rectangle-5-bank",
  x: 13,
  y: 0,
  width: 5,
  height: 24,
  rx: 2
}), React.createElement("rect", {
  id: "Rectangle-5-Copy-bank",
  x: 0,
  y: 0,
  width: 5,
  height: 24,
  rx: 2
}), React.createElement("rect", {
  id: "Rectangle-5-Copy-3-bank",
  x: 39,
  y: 0,
  width: 5,
  height: 24,
  rx: 2
}), React.createElement("rect", {
  id: "Rectangle-5-Copy-2-bank",
  x: 26,
  y: 0,
  width: 5,
  height: 24,
  rx: 2
})))));

var SvgBank = function SvgBank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "60px",
    height: "58px",
    viewBox: "0 0 60 58",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bank.37a534f8.svg";
export { ForwardRef as ReactComponent };